// extracted by mini-css-extract-plugin
export default {"pointCard":"PointCard_pointCard__E06QP","cardContent":"PointCard_cardContent__KQDQM"};